import { Box, Typography } from "@mui/material";

import { FONT_PRIMARY } from "@/theme/typography";
import useResponsive from "@/hooks/useResponsive";
import { useFeatureMedia } from "../utils/useFeatureMedia";

interface IProps {
  title: string;
  isActive?: boolean;
}

const Heading: React.FC<IProps> = ({ title, isActive = false }) => {
  const isMobile = useResponsive("down", "lg");
  const { isLargeScreen } = useFeatureMedia();

  return (
    <>
      {isMobile || (!isActive && !isLargeScreen) ? (
        <Typography
          variant="h2"
          fontFamily={FONT_PRIMARY}
          color={isActive ? "text.accent" : "text.primary"}
          fontSize={{ xs: 24, sm: 32, md: 40 }}
          mb={isActive ? 2 : 0}
        >
          {title}
        </Typography>
      ) : (
        <Box
          sx={{
            width: "400px",
            position: "absolute",
            left: 0,
            bottom: "8px",
            transform: "rotate(-90deg) translate(50%, -226%)",
          }}
        >
          <Typography
            variant="h2"
            fontFamily={FONT_PRIMARY}
            color={isActive ? "text.accent" : "text.primary"}
            fontSize={{ xs: 24, sm: 32, md: 40 }}
          >
            {title}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default Heading;
